import { DialogBox } from "@/components/DialogBox/DialogBox";
import { Scope, usePermissions } from "@/hooks/permissions";
import { Box, CircularProgress, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

export const InsufficientCreditsDialog = ({
  open,
  setOpen,
  showExtendedMessage
}: {
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  showExtendedMessage?: boolean;
}) => {
  const { t } = useTranslation("common");
  const { [Scope.UpdateFinancials]: canBuyCredits, isLoading } = usePermissions();

  const extendedKeySuffix = showExtendedMessage ? "Long" : "";
  const body = canBuyCredits
    ? t("message.insufficientCreditsAdmin" + extendedKeySuffix)
    : t("message.insufficientCredits" + extendedKeySuffix);

  return (
    <DialogBox
      sx={{ ".MuiPaper-root": { width: "100%", maxWidth: showExtendedMessage ? "800px" : "600px", margin: "16px" } }}
      args={undefined}
      title={t("title.insufficientCredits")}
      message={
        isLoading ? (
          <Box sx={{ display: "flex", justifyContent: "center" }}>
            <CircularProgress />
          </Box>
        ) : (
          <Typography sx={{ whiteSpace: "pre-wrap" }}>{body}</Typography>
        )
      }
      onClose={(approve) => {
        if (approve && canBuyCredits) {
          window.open("/credits", "_blank");
        }
      }}
      open={open}
      setOpen={setOpen}
      hideDecline={isLoading || !canBuyCredits}
      confirmText={canBuyCredits ? t("button.topUp") : t("button.ok")}
      declineText={t("button.ok")}
    />
  );
};
